<div [formGroup]="form" fxLayout="column">
  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field>
      <mat-label>NDR Request Date</mat-label>
      <input
        matInput
        formControlName="ndrRequestDate"
        [matDatepicker]="ndrRequestDatePicker"
        [min]="minDate"
        [max]="maxDate"
        required
      />
      <mat-datepicker-toggle matSuffix [for]="ndrRequestDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #ndrRequestDatePicker></mat-datepicker>
      <mat-error *ngIf="form.controls.ndrRequestDate.hasError('matDatepickerMin')"
        >Date is too far in the past.</mat-error
      >
      <mat-error *ngIf="form.controls.ndrRequestDate.hasError('matDatepickerMax')"
        >Date must be on or before today.</mat-error
      >
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field>
      <mat-label>Processing State</mat-label>
      <mat-select formControlName="processingState">
        <mat-option
          *ngFor="let option of processingStateOptions"
          [value]="option.value"
          [disabled]="!option.selectable"
        >
          {{ option.value | humanize }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
